module.exports = __webpack_public_path__ + "img/stock1.dfca7efd.png";